import * as React from 'react'
import styled from 'styled-components'
import { constants, TextSettingsProps } from '../../constants'
import StyledLink from '../common/StyledLink'
import { Language } from '../../Language'
import { FontsContext } from '../../context'
import { withPrefix } from 'gatsby'

interface Props {
  title: string
  spOnly?: boolean
  messages: any
  language: Language
}

const Breadcrumbs = ({ title, spOnly, messages, language }: Props) => {
  const fonts = React.useContext(FontsContext)

  return (
    <Wrapper spOnly={spOnly}>
      <Breadcrumb nowrap settings={fonts.texts.breadcrumbs}>
        <LinkWrapper
          settings={fonts.texts.breadcrumbs}
          href={withPrefix(`/${language}/`)}
        >
          {messages.pages.home}
        </LinkWrapper>
      </Breadcrumb>
      <Breadcrumb nowrap settings={fonts.texts.breadcrumbs}>
        <LinkWrapper
          settings={fonts.texts.breadcrumbs}
          href={withPrefix(`/${language}/ingredients/`)}
        >
          {messages.pages.ingredients}
        </LinkWrapper>
      </Breadcrumb>
      <Breadcrumb settings={fonts.texts.breadcrumbs}>{title}</Breadcrumb>
    </Wrapper>
  )
}

const Wrapper = styled.ol`
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
  margin-bottom: 32px;
  ${({ spOnly }: { spOnly?: boolean }) => spOnly && `margin-bottom: 48px`};

  @media only screen and (min-width: ${constants.breakpoints.pc}) {
    width: ${constants.dimensions.contentsPercent};
    margin: 0 auto 108px;
    justify-content: flex-start;

    ${({ spOnly }: { spOnly?: boolean }) => spOnly && `display: none`};
  }
`

interface BreadCrumbProps extends TextSettingsProps {
  nowrap?: boolean
}

const Breadcrumb = styled.li<BreadCrumbProps>`
  padding: 0 10px;
  border-right: 1px solid ${constants.colors.text.normal};
  color: ${constants.colors.text.red};
  font-size: ${({ settings }) => settings.sp.size};
  line-height: 1;
  display: flex;
  align-items: center;

  &:last-child {
    border-right: none;
  }

  ${({ nowrap }) => nowrap && `white-space: nowrap;`}

  @media only screen and (min-width: ${constants.breakpoints.pc}) {
    border-right: none;
    padding: 0;
    font-size: ${({ settings }) => settings.pc.size};

    &:after {
      content: '/';
      color: ${constants.colors.text.normal};
      display: inline-block;
      padding: 0 10px;
    }

    &:last-child {
      &:after {
        display: none;
      }
    }
  }
`

const LinkWrapper = styled(StyledLink)<TextSettingsProps>`
  display: inline-block;
  color: ${constants.colors.text.normal};
  font-size: ${({ settings }) => settings.sp.size};
  line-height: 1;
  letter-spacing: 0.6px;

  @media only screen and (min-width: ${constants.breakpoints.pc}) {
    font-size: ${({ settings }) => settings.pc.size};
  }
`

export default Breadcrumbs
